import React from 'react'

const TwitterIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      color="#102538"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="54" height="54" rx="5" fill="white" />
      <g clipPath="url(#clip0_35751_23457)">
        <path
          d="M35.1293 14.7065H39.4227L29.996 25.4399L41.0093 39.9999H32.3667L25.6 31.1519L17.8533 39.9999H13.56L23.5467 28.5199L13 14.7065H21.8573L27.9707 22.7892L35.1293 14.7065ZM33.6267 37.4799H36.0067L20.6067 17.1332H18.0493L33.6267 37.4799Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_35751_23457">
          <rect
            width="28"
            height="27"
            fill="white"
            transform="translate(13 14)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TwitterIcon
